import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_PROCESS = "GET_LIST_PROCESS";
export const GET_DETAIL_PROCESS = "GET_DETAIL_PROCESS";
export const UPDATE_PROCESS = "UPDATE_PROCESS";
export const SAVE_PROCESS = "SAVE_PROCESS";
export const DELETE_PROCESS = "DELETE_PROCESS";
export const SET_LIST_PROCESS = "SET_LIST_PROCESS";
export const SET_DETAIL_PROCESS = "SET_DETAIL_PROCESS";


const state = {
    process: [],
    processDetail: {}
};

const getters = {
    process(state) {
        return state.process;
    },
    processDetail(state) {
        return state.processDetail;
    },


};

const actions = {
    [GET_LIST_PROCESS](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_PROCESS}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_PROCESS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PROCESS](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PROCESS}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PROCESS, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_PROCESS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PROCESS}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_PROCESS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PROCESS}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_PROCESS](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PROCESS}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_PROCESS](state, data) {
        state.process = data.data;
    },
    [SET_DETAIL_PROCESS](state, data) {
        state.processDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};